import { t } from '../i18n';
import { CenteredPage } from '../ui';

/** Shown when the build has no (or malformed) Supabase settings. */
export function SetupScreen({
  missing,
  invalid,
}: {
  missing: readonly string[];
  invalid: readonly string[];
}) {
  return (
    <CenteredPage>
      <h1 className="text-3xl font-semibold tracking-[-0.03em]">{t('connection.missing.title')}</h1>
      <div role="alert" className="grid gap-2 text-sm">
        {missing.length > 0 ? (
          <p>{t('connection.missing.body', { vars: missing.join(', ') })}</p>
        ) : null}
        {invalid.length > 0 ? (
          <p>{t('connection.invalid.body', { vars: invalid.join(', ') })}</p>
        ) : null}
      </div>
    </CenteredPage>
  );
}
